import { LocationPin } from '@components/icons'
import { LoadingDots } from '@components/ui'
import useStore from '../hooks/useStore'
import { SuggestionType } from '../types'
import SearchInput from './SearchInput'

export const SearchContainer = () => {
  const [
    { componentRestrictions, currentPositionStatus },
    { setCurrentPosition, setStatusCurrentPosition, setSearchLocation },
  ] = useStore()

  const handleSelectSuburb = (selection: SuggestionType) => {
    setSearchLocation(selection)
  }

  const handleGetCurrentPosition = () => {
    setStatusCurrentPosition(true)
    navigator.geolocation.getCurrentPosition((event) => {
      const {
        coords: { latitude, longitude },
      } = event
      setCurrentPosition({
        lat: latitude,
        lng: longitude,
      })
    })
  }

  return (
    <div className="flex relative flex-col border border-gray-500 p-4">
      <div className="h-10 w-full w-68 mx-auto bg-center bg-contain bg-no-repeat absolute top-0 left-0 right-0" />
      <div className="text-center mt-6 mb-10">
        <h3 className="text-20">FIND YOUR STORE</h3>
      </div>
      <div className="flex flex-col">
        <button
          className="flex justify-center items-center bg-gray-800 text-white py-3 text-14"
          onClick={handleGetCurrentPosition}
        >
          {currentPositionStatus?.loading ? (
            <LoadingDots />
          ) : (
            <LocationPin className="mr-2 text-white" />
          )}
          {!currentPositionStatus?.loading && 'Use my current location'}
        </button>
        <div className="text-center my-4 text-sm">OR</div>
        <SearchInput
          onSelect={handleSelectSuburb}
          componentRestrictions={componentRestrictions}
        />
      </div>
    </div>
  )
}
